import { writable } from "svelte/store";
export const config = {
    uri: "https://api.media02.ogonline.nl",
};
export const token = writable(localStorage.getItem("apiToken") || "");
let _token;
token.subscribe((value) => {
    _token = value;
    localStorage.setItem("apiToken", value);
});
export async function login(username, password) {
    const request = new Request(config.uri + "/token", {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
    });
    const response = await fetch(request, {
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
    });
    const data = await response.json();
    token.set(data.token);
    return true;
}
export async function logout() {
    const headers = new Headers();
    if (_token) {
        headers.set("X-Token", _token);
    }
    const request = new Request(config.uri + "/token", {
        method: "DELETE",
        mode: "cors",
        cache: "no-cache",
        headers
    });
    const response = await fetch(request);
    const data = await response.json();
    token.set("");
    return true;
}
export async function checkToken() {
    const headers = new Headers();
    if (_token) {
        headers.set("X-Token", _token);
    }
    const request = new Request(config.uri + "/token", {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers
    });
    try {
        const response = await fetch(request);
        return true;
    }
    catch (e) {
        token.set("");
        return false;
    }
}
export function findResult() {
    return {
        result: [],
        total: 0,
    };
}
export function isFindResult(result) {
    return result.hasOwnProperty("total");
}
export function findOneResult() {
    return {
        result: {},
    };
}
export function isFindOneResult(result) {
    return !result.hasOwnProperty("total");
}
export function string2date(data, keys) {
    if (isFindResult(data)) {
        data.result = data.result.map((item) => {
            keys.forEach((key) => {
                item[key] = new Date(item[key]);
            });
            return item;
        });
        return data;
    }
    if (isFindOneResult(data)) {
        keys.forEach((key) => {
            data[key] = new Date(data[key]);
        });
        return data;
    }
}
export async function find(path, query = {}, options = {}) {
    try {
        const headers = new Headers();
        if (_token) {
            headers.set("X-Token", _token);
        }
        if (query) {
            path += "?" + Object.keys(query).map((key) => {
                return `${key}=${query[key]}`;
            }).join("&");
        }
        const request = new Request(config.uri + path, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            headers
        });
        const response = await fetch(request);
        const data = await response.json();
        if (options.stringToDate) {
            data.result = data.result.map((item) => {
                options.stringToDate.forEach((key) => {
                    item[key] = new Date(item[key]);
                });
                return item;
            });
        }
        return data;
    }
    catch (e) {
        throw new Error(e);
    }
}
export async function findOne(path) {
    try {
        const headers = new Headers();
        if (_token) {
            headers.set("X-Token", _token);
        }
        const request = new Request(config.uri + path, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            headers
        });
        const response = await fetch(request);
        const data = await response.json();
        return data;
    }
    catch (e) {
        throw new Error(e);
    }
}
export async function insertOne(path, data) {
    try {
        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        if (_token) {
            headers.set("X-Token", _token);
        }
        const request = new Request(config.uri + path, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers
        });
        const response = await fetch(request, {
            body: JSON.stringify(data),
        });
        const result = await response.json();
        return result;
    }
    catch (e) {
        throw new Error(e);
    }
}
export async function deleteOne(path, query) {
    try {
        const headers = new Headers();
        const uri = new URL(config.uri + path);
        if (query) {
            Object
                .keys(query)
                .forEach(key => uri.searchParams.append(key, query[key]));
        }
        if (_token) {
            headers.set("X-Token", _token);
        }
        const request = new Request(uri.toString(), {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            headers
        });
        await fetch(request);
    }
    catch (e) {
        throw new Error(e);
    }
}
